import React from 'react';
import pluralize from 'pluralize';

interface CreateUserSuccessProps {
  title: string;
  uniqDataLength: number;
  parentClasses?: {
    bold?: string;
  };
}

const CreateUserSuccess = ({
  title,
  parentClasses,
  uniqDataLength,
}: CreateUserSuccessProps) => (
  <span>
    You just created{' '}
    <span className={parentClasses.bold}>
      {pluralize(title, uniqDataLength, true)}
    </span>
  </span>
);

export default CreateUserSuccess;
